// Single source of truth for the deckbuilder profiles a user can link to their
// Commandersalt account. `key` is the provider value the API expects; `label`
// is what the UI shows, and the link dialog lowercases it back into `key` when
// it calls out. Consumed by the linked-accounts manager and by the public
// profile page's "Linked profiles" pills.

export const LINK_PROVIDERS = [
    { key: 'moxfield', label: 'Moxfield', favicon: 'https://moxfield.com/favicon.png' },
    { key: 'archidekt', label: 'Archidekt', favicon: 'https://archidekt.com/favicon.ico' },
    { key: 'tappedout', label: 'TappedOut', favicon: 'https://tappedout.net/favicon.ico' },
    {
        key: 'mythichub',
        label: 'MythicHub',
        favicon: 'https://mythichub.com/favicon.ico',
        // The field this site calls its bio, and where the user edits it.
        // Providers without these get the generic "paste it in your bio" copy.
        bioField: 'About',
        settingsUrl: 'https://mythichub.com/profile/settings',
        // MythicHub's own signup rule. The API enforces it as a security control
        // and rejects anything else — encoded input included — before it makes
        // any outbound request, answering with the generic "auth code not found".
        // That reads as "the code isn't in your bio" to someone whose actual
        // problem is a typo'd handle, so gate it in the form too.
        usernamePattern: /^[a-zA-Z0-9_-]{3,50}$/,
        usernameHint: 'MythicHub usernames are 3–50 characters: letters, numbers, underscores, or hyphens only.',
    },
];

export function getLinkProvider(key) {
    const lower = String(key || '').toLowerCase();
    return LINK_PROVIDERS.find((provider) => provider.key === lower) || null;
}

// Falls back to whatever the API handed us so an unrecognized provider still
// renders a name rather than blanking out.
export function getLinkProviderLabel(key) {
    return getLinkProvider(key)?.label || key;
}

export function getLinkProviderFavicon(key) {
    return getLinkProvider(key)?.favicon || '';
}
